const { api } = require("./api")

const DeductionRequestService = {
  all(params) {
    return api.get('deductions', params)
  },
  store(params) {
    return api.post('deductions', params)
  }
}

export default DeductionRequestService